import React from 'react'

// Control-center style "auto orientation" glyph: a rotation ring wrapping a
// small padlock (mirrors the phone's screen-rotation control). Inherits the
// current text colour and matches lucide's stroke style.
const AutoRotateIcon = ({ size = 18 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M20 13a8 8 0 0 1-14 5" />
        <polyline points="6 22 6 18 10 18" />
        <path d="M4 11a8 8 0 0 1 14-5" />
        <polyline points="18 2 18 6 14 6" />
        <rect x="9.4" y="11.4" width="5.2" height="4.2" rx="0.9" />
        <path d="M10.5 11.4v-1a1.5 1.5 0 0 1 3 0v1" />
    </svg>
)

export default AutoRotateIcon
